import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [preselectedCategory, setPreselectedCategory] = useState(null);
  const [preselectedService, setPreselectedService] = useState(null);

  const openBooking = (category = null, service = null) => {
    setPreselectedCategory(category);
    setPreselectedService(service);
    setIsBookingOpen(true);
  };

  const closeBooking = () => {
    setIsBookingOpen(false);
    setPreselectedCategory(null);
    setPreselectedService(null);
  };

  return (
    <BookingContext.Provider value={{
      isBookingOpen,
      preselectedCategory,
      preselectedService,
      openBooking,
      closeBooking
    }}>
      {children}
    </BookingContext.Provider>
  );
};

export default BookingContext;
